import request from '@/api/request'
/**
 * 获取首页Banner
 */
export function bannerListApi () {
  return request({
    url: '/banner/list',
    method: 'get'
  })
}

/**
 * 首页热门申办
 */
export function bidHotApi () {
  return request({
    url: '/online/bid_hot',
    method: 'get'
  })
}

/**
 * 搜索
 */
export function searchResultApi (query) {
  return request({
    url: '/search/result',
    method: 'get',
    params: query
  })
}

/**
 * 热门搜索标签
 */
export function searchHotApi (query) {
  return request({
    url: '/search/hot',
    method: 'get',
    params: query
  })
}

/**
 * 热门搜索标签搜索量加一
 */
export function searchNumApi (query) {
  return request({
    url: '/search/num',
    method: 'post',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/index/index.js